module.exports = __webpack_public_path__ + "img/4.2.TN.1457a59b.png";